export const designationConstants = {
    LOGIN_REQUEST: 'DESIGNATIONS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'DESIGNATIONS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'DESIGNATIONS_LOGIN_FAILURE',

    LOGOUT: 'DESIGNATIONS_LOGOUT',

    GETALL_REQUEST: 'DESIGNATIONS_GETALL_REQUEST',
    GETALL_SUCCESS: 'DESIGNATIONS_GETALL_SUCCESS',
    GETALL_FAILURE: 'DESIGNATIONS_GETALL_FAILURE',

    GET_ALL_DESIGNATION_REQUEST: 'DESIGNATIONS_GET_ALL_DESIGNATION_REQUEST',
    GET_ALL_DESIGNATION_SUCCESS: 'DESIGNATIONS_GET_ALL_DESIGNATION_SUCCESS',
    GET_ALL_DESIGNATION_FAILURE: 'DESIGNATIONS_GET_ALL_DESIGNATION_FAILURE',
    
    GETALL_DESIGNATION_NOTIFY_REQUEST: 'GETALL_DESIGNATION_NOTIFY_REQUEST',
    GETALL_DESIGNATION_NOTIFY_SUCCESS: 'GETALL_DESIGNATION_NOTIFY_SUCCESS',
    GETALL_DESIGNATION_NOTIFY_FAILURE: 'GETALL_DESIGNATION_NOTIFY_FAILURE',

    UPDATE_DESIGNATION_NOTIFY_REQUEST: 'UPDATE_DESIGNATION_NOTIFY_REQUEST',
    UPDATE_DESIGNATION_NOTIFY_SUCCESS: 'UPDATE_DESIGNATION_NOTIFY_SUCCESS',
    UPDATE_DESIGNATION_NOTIFY_FAILURE: 'UPDATE_DESIGNATION_NOTIFY_FAILURE',


    ADD_RESTAURANT_DESIGNATION_REQUEST: 'ADD_RESTAURANT_DESIGNATION_REQUEST',
    ADD_RESTAURANT_DESIGNATION_SUCCESS: 'ADD_RESTAURANT_DESIGNATION_SUCCESS',
    ADD_RESTAURANT_DESIGNATION_FAILURE: 'ADD_RESTAURANT_DESIGNATION_FAILURE',

    FILE_UPLOAD_STATUS_REQUEST: 'FILE_UPLOAD_STATUS_REQUEST',
    FILE_UPLOAD_STATUS_SUCCESS: 'FILE_UPLOAD_STATUS_SUCCESS',
    FILE_UPLOAD_STATUS_FAILURE: 'FILE_UPLOAD_STATUS_FAILURE',


    GET_RESTAURANT_REQUEST: 'GET_RESTAURANT_REQUEST',
    GET_RESTAURANT_SUCCESS: 'GET_RESTAURANT_SUCCESS',
    GET_RESTAURANT_FAILURE: 'GET_RESTAURANT_FAILURE',
    
    ADD_MENU_REQUEST: 'ADD_MENU_REQUEST',
    ADD_MENU_SUCCESS: 'ADD_MENU_SUCCESS',
    ADD_MENU_FAILURE: 'ADD_MENU_FAILURE',


    ADD_ITEM_REQUEST: 'ADD_ITEM_REQUEST',
    ADD_ITEM_SUCCESS: 'ADD_ITEM_SUCCESS',
    ADD_ITEM_FAILURE: 'ADD_ITEM_FAILURE',

    DEL_ITEM_REQUEST: 'DEL_ITEM_REQUEST',
    DEL_ITEM_SUCCESS: 'DEL_ITEM_SUCCESS',
    DEL_ITEM_FAILURE: 'DEL_ITEM_FAILURE',

    UPDATE_CATEGORY_REQUEST: 'UPDATE_CATEGORY_REQUEST',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

    UPDATE_ITEM_REQUEST: 'UPDATE_ITEM_REQUEST',
    UPDATE_ITEM_SUCCESS: 'UPDATE_ITEM_SUCCESS',
    UPDATE_ITEM_FAILURE: 'UPDATE_ITEM_FAILURE',


    STATS_REQUEST: 'STATS_REQUEST',
    STATS_SUCCESS: 'STATS_SUCCESS',
    STATS_FAILURE: 'STATS_FAILURE',

};
